<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.queryValue" class="input-with-select" size="small">
                        <el-select v-model="params.queryType" slot="prepend" placeholder="请选择">
                            <el-option label="用户ID" :value="1"></el-option>
                            <el-option label="歌曲ID" :value="2"></el-option>
                            <el-option label="歌曲名称" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.display" placeholder="请选择" size="small">
                        <el-option label="仅看显示的" :value="1"></el-option>
                        <el-option label="仅看隐藏的" :value="0"></el-option>
                        <el-option label="不限制状态" value=""></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.styleType" placeholder="请选择" size="small" @change="params.tag='';params.style=''">
                        <el-option label="音乐风格分类" :value="1"></el-option>
                        <el-option label="音乐风格" :value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-if="params.styleType == 1" v-model="params.style" placeholder="请选择音乐风格分类" size="small">
                        <el-option v-for="(item,index) in styleList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                    <el-cascader v-if="params.styleType == 2" v-model="params.tag" :options="tagList" :props="{value:'id',label:'name',children:'tags',emitPath:false}" size="small" style="width:100%"></el-cascader>
                </el-col>
                <el-col :xs="24" :sm="12" :md="16" :lg="11" :xl="8">
                    <div class="clearfix timeType">
                        <el-input class="input-with-select fl" size="small">
                            <el-select v-model="params.timeType" slot="prepend" placeholder="请选择">
                                <el-option label="上传时间" :value="1"></el-option>
                            </el-select>
                        </el-input>
                        <el-date-picker
                            v-model="datetimerange"
                            type="datetimerange"
                            start-placeholder="开始时间"
                            end-placeholder="结束时间"
                            class="fl"
                            size="small"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            unlink-panels
                            >
                        </el-date-picker>
                    </div>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="userId" label="用户ID"></el-table-column>
                <el-table-column prop="createUserName" label="用户名称" show-overflow-tooltip></el-table-column>
                <el-table-column prop="id" label="歌曲ID"></el-table-column>
                <el-table-column prop="name" label="歌曲名称" min-width="120" show-overflow-tooltip></el-table-column>

                <el-table-column prop="styleTags" label="风格" show-overflow-tooltip>
                    <!-- <template slot-scope="scope">
                        <span v-for="(item,index) in scope.row.tagVOS" :key="index">
                            {{item.styleName}}{{item.tagName ? '-'+item.tagName : item.tagName}}
                            {{scope.row.tagVOS.length > index+1 ? '/' : ''}}
                        </span>   
                    </template> -->
                </el-table-column>
                <el-table-column prop="time" label="时长"></el-table-column>
                <el-table-column prop="clickNum" label="播放次数"></el-table-column>
                <el-table-column prop="createTime" label="上传时间" min-width="150"></el-table-column>
                <el-table-column prop="display" label="状态">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.display == 1" type="success" size="mini">显示</el-tag>
                        <el-tag v-else type="info" size="mini">隐藏</el-tag>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button
                            v-if="$utils.have('/music/update')"
                            type="text"
                            size="small"
                            icon="el-icon-edit"
                            @click="edit(scope.row.id)"
                            >编辑</el-button
                        >
                        <el-button
                            v-if="scope.row.playUrl"
                            type="text"
                            size="small"
                            icon="el-icon-video-play"
                            @click="$player.play(scope.row)"
                            >播放</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <music-edit ref="musicEdit" @onUpdate="getDataList()"></music-edit>
    </div>
</template>

<script>
import MusicEdit from './components/music-edit';
import {fetchStyleList,fetchAllTag} from '@/assets/js/commonApi';
const defaultParams = {
    pageNo: 1,
    queryType:1,
    queryValue:'',
    styleType:1,
    style:'',
    tag:'',
    timeType:1,
    startTime:'',
    endTime:'',
    display:1
}
export default {
    components:{
        MusicEdit
    },
    data() {
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageSize: this.$pageSizes[0],
            },
            listLoading: false, 
            datetimerange:[],
            styleList:[],
            tagList:[]
        };
    },
    mounted(){
        this.getStyleList();
        this.getTagList();
        this.getDataList();
    },
    methods: {
        getStyleList(){
            fetchStyleList().then( res => {
                const { state, msg, result } = res.data;
                if(state == 1){
                    this.styleList = result || [];
                }
            })
        },
        getTagList(){
            fetchAllTag().then( res => {
                const { state, msg, result } = res.data;
                if(state == 1){
                    this.tagList = result || [];
                }
            })
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/music/getPageList",
                method: "POST",
                data: {
                    ...this.params,
                    startTime:this.datetimerange && this.datetimerange[0] || null,
                    endTime:this.datetimerange && this.datetimerange[1] || null
                },
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        this.dataList = result.result || [];
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //编辑事件
        edit(id){
            this.$refs.musicEdit.show(id);
        }
    },
};
</script>
